import type { ExpressionErrorAlertProps } from "./expression-error-alert.type";

import { Trans } from "react-i18next";

import { HelpCenterLink } from "@/modules/help-center";
import { Alert } from "@/ui/alert";

import { getExpressionErrorInfos } from "../expression.helper";

import { ExpressionErrorAlertDetails } from "./expression-error-alert-details";

export const ExpressionErrorAlert = ({
  error: errorInput,
}: ExpressionErrorAlertProps) => {
  const error = getExpressionErrorInfos(errorInput);

  if (!error) return null;

  const canShowDetails =
    error.code === "UNEXPECTED_ERROR" && Boolean(error.message);

  return (
    <Alert
      display
      closable={false}
      title={
        <Trans
          i18nKey={`expression:error.${error.code}`}
          components={{ HelpLink: <HelpCenterLink /> }}
        />
      }
      description={
        canShowDetails ? (
          <ExpressionErrorAlertDetails message={error.message} />
        ) : (
          ""
        )
      }
    />
  );
};
